import { Col, Row } from "react-bootstrap";
import './SXWYIcon.css';

export default function SXWYIcon() {

    return (
        <Row id='sxwy'>
            <Col>
                <div className="cardStyle d-flex align-items-center justify-content-center">
                    <Row>
                        <Col className="d-flex align-items-center justify-content-center">
                            <span className="textStyle">十二生肖密码 年份</span>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    )
}